import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import clientConfig from '../../../../config/client-config';

export type AvailableThemes = 'LIGHT' | 'DARK' | 'HIGH_CONTRAST' | 'CHRISTMASS';

export interface ThemeState {
  currentTheme: AvailableThemes;
  logo: string;
}

export const LOCAL_STORAGE_THEME_NAME = 'system-theme';

const getLogo = (currentTheme: string) => {
  const logos = clientConfig.logos;
  if (currentTheme === 'DARK') return logos.dark;
  if (currentTheme === 'HIGH_CONTRAST') return logos.highContrast;
  if (currentTheme === 'CHRISTMASS') return logos.christmas;
  return logos.light;
};

const isChristmass = new Date().getMonth() === 11;
let initialTheme: AvailableThemes = (localStorage.getItem(LOCAL_STORAGE_THEME_NAME) as AvailableThemes) ?? 'LIGHT';

if (!isChristmass && initialTheme === 'CHRISTMASS') {
  localStorage.setItem(LOCAL_STORAGE_THEME_NAME, 'LIGHT');

  initialTheme = 'LIGHT';
}

const initialState: ThemeState = {
  currentTheme: initialTheme,
  logo: getLogo(initialTheme)
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<AvailableThemes>) => {
      const newState = {
        ...state,
        currentTheme: action.payload,
        logo: getLogo(action.payload)
      };

      localStorage.setItem(LOCAL_STORAGE_THEME_NAME, action.payload);

      return newState;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setTheme } = themeSlice.actions;

export default themeSlice.reducer;
